import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=14ca79ce&scoped=true"
import script from "./Costs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Costs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Costs.vue?vue&type=style&index=0&id=14ca79ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca79ce",
  null
  
)

export default component.exports